/**
 * Classement Lapaire Plus par pays (instantané ventes).
 * Généré depuis `lapaire_plus_priority_by_country.csv` — remplacer ce fichier
 * entièrement lors d'une mise à jour du classement. Clé : code pays ISO, puis SKU.
 */
export const LAPAIRE_PLUS_RANKING: Record<string, Record<string, number>> = {
  CI: {
    "Malick-C1": 1,
    "Yemi-C1": 2,
    "Tiken-C1": 3,
    "Adekunle-C1": 4,
    "Ouidah-C1": 5,
    "Aliko-C1": 6,
    "Kindu-C1": 7,
    "Cabinda-C1": 8,
    "Fela-C1": 9,
    "Koffi-C1": 10,
    "Didier-C1": 11,
    "Matam-C1": 12,
    "Sadio-C1": 13,
    "Chimamanda-C1": 14,
    "Kumba-C1": 15,
    "Tiwa-C1": 16,
    "Tyla-C1": 17,
    "Fally-C1": 18,
    "Alpha-C1": 19,
    "Seydou-C1": 20,
    "Isiro-C1": 21,
    "Dakar-C2": 22,
    "Aneho-C1": 23,
    "Diourbel-C1": 24,
  },
  TG: {
    "Yemi-C1": 1,
    "Adekunle-C1": 2,
    "Kindu-C1": 3,
    "Malick-C1": 4,
    "Cabinda-C1": 5,
    "Tiwa-C1": 6,
    "Aliko-C1": 7,
    "Didier-C1": 8,
    "Fela-C1": 9,
    "Ouidah-C1": 10,
    "Tiken-C1": 11,
    "Matam-C1": 12,
    "Tyla-C1": 13,
    "Chimamanda-C1": 14,
    "Koffi-C1": 15,
    "Sadio-C1": 16,
    "Kumba-C1": 17,
    "Fally-C1": 18,
    "Seydou-C1": 19,
    "Isiro-C1": 20,
    "Alpha-C1": 21,
    "Aneho-C1": 22,
    "Dakar-C2": 23,
    "Diourbel-C1": 24,
  },
  BF: {
    "Kindu-C1": 1,
    "Didier-C1": 2,
    "Malick-C1": 3,
    "Yemi-C1": 4,
    "Aliko-C1": 5,
    "Fela-C1": 6,
    "Tiken-C1": 7,
    "Matam-C1": 8,
    "Seydou-C1": 9,
    "Ouidah-C1": 10,
    "Tyla-C1": 11,
    "Adekunle-C1": 12,
    "Cabinda-C1": 13,
    "Tiwa-C1": 14,
    "Fally-C1": 15,
    "Koffi-C1": 16,
    "Chimamanda-C1": 17,
    "Sadio-C1": 18,
    "Kumba-C1": 19,
    "Aneho-C1": 20,
    "Alpha-C1": 21,
    "Isiro-C1": 22,
    "Dakar-C2": 23,
    "Diourbel-C1": 24,
  },
  UG: {
    "Kindu-C1": 1,
    "Yemi-C1": 2,
    "Matam-C1": 3,
    "Fela-C1": 4,
    "Malick-C1": 5,
    "Fally-C1": 6,
    "Didier-C1": 7,
    "Seydou-C1": 8,
    "Tyla-C1": 9,
    "Aliko-C1": 10,
    "Aneho-C1": 11,
    "Tiwa-C1": 12,
    "Adekunle-C1": 13,
    "Tiken-C1": 14,
    "Cabinda-C1": 15,
    "Ouidah-C1": 16,
    "Sadio-C1": 17,
    "Kumba-C1": 18,
    "Koffi-C1": 19,
    "Chimamanda-C1": 20,
    "Alpha-C1": 21,
    "Isiro-C1": 22,
    "Dakar-C2": 23,
    "Diourbel-C1": 24,
  },
  SN: {
    "Aliko-C1": 1,
    "Didier-C1": 2,
    "Ouidah-C1": 3,
    "Yemi-C1": 4,
    "Adekunle-C1": 5,
    "Fela-C1": 6,
    "Tiwa-C1": 7,
    "Tiken-C1": 8,
    "Koffi-C1": 9,
    "Malick-C1": 10,
    "Isiro-C1": 11,
    "Diourbel-C1": 12,
    "Sadio-C1": 13,
    "Kindu-C1": 14,
    "Seydou-C1": 15,
    "Fally-C1": 16,
    "Cabinda-C1": 17,
    "Tyla-C1": 18,
    "Alpha-C1": 19,
    "Chimamanda-C1": 20,
    "Aneho-C1": 21,
    "Dakar-C2": 22,
    "Matam-C1": 23,
    "Kumba-C1": 24,
  },
  ML: {
    "Didier-C1": 1,
    "Aliko-C1": 2,
    "Matam-C1": 3,
    "Adekunle-C1": 4,
    "Yemi-C1": 5,
    "Kindu-C1": 6,
    "Ouidah-C1": 7,
    "Tyla-C1": 8,
    "Malick-C1": 9,
    "Fela-C1": 10,
    "Tiken-C1": 11,
    "Tiwa-C1": 12,
    "Cabinda-C1": 13,
    "Seydou-C1": 14,
    "Koffi-C1": 15,
    "Sadio-C1": 16,
    "Fally-C1": 17,
    "Chimamanda-C1": 18,
    "Kumba-C1": 19,
    "Aneho-C1": 20,
    "Alpha-C1": 21,
    "Isiro-C1": 22,
    "Dakar-C2": 23,
    "Diourbel-C1": 24,
  },
  BJ: {
    "Yemi-C1": 1,
    "Kindu-C1": 2,
    "Cabinda-C1": 3,
    "Ouidah-C1": 4,
    "Matam-C1": 5,
    "Aliko-C1": 6,
    "Didier-C1": 7,
    "Adekunle-C1": 8,
    "Koffi-C1": 9,
    "Malick-C1": 10,
    "Tiken-C1": 11,
    "Fela-C1": 12,
    "Tiwa-C1": 13,
    "Sadio-C1": 14,
    "Chimamanda-C1": 15,
    "Seydou-C1": 16,
    "Fally-C1": 17,
    "Tyla-C1": 18,
    "Kumba-C1": 19,
    "Aneho-C1": 20,
    "Alpha-C1": 21,
    "Isiro-C1": 22,
    "Dakar-C2": 23,
    "Diourbel-C1": 24,
  },
  MA: {
    "Aliko-C1": 1,
    "Sadio-C1": 2,
    "Yemi-C1": 3,
    "Kindu-C1": 4,
    "Alpha-C1": 5,
    "Tiwa-C1": 6,
    "Koffi-C1": 7,
    "Cabinda-C1": 8,
    "Aneho-C1": 9,
    "Malick-C1": 10,
    "Didier-C1": 11,
    "Adekunle-C1": 12,
    "Fela-C1": 13,
    "Tiken-C1": 14,
    "Ouidah-C1": 15,
    "Matam-C1": 16,
    "Tyla-C1": 17,
    "Seydou-C1": 18,
    "Fally-C1": 19,
    "Chimamanda-C1": 20,
    "Kumba-C1": 21,
    "Isiro-C1": 22,
    "Dakar-C2": 23,
    "Diourbel-C1": 24,
  },
};

const normalize = (v: string) => v.trim().toLowerCase();

/**
 * Montures toujours affichées en dernier, quel que soit le pays ou le CSV.
 * L'ordre du tableau détermine leur ordre final.
 */
export const LAPAIRE_PLUS_ALWAYS_LAST = ["Dakar-C2", "Diourbel-C1"];

/** Rang attribué aux montures non classées (après les montures classées). */
const UNRANKED_RANK = 1_000_000;

/**
 * Rang d'une monture pour un pays.
 * Ordre : montures classées (CSV) < montures non classées < montures "always last".
 * Le CSV est clé par nom de monture (ex. "Dakar-C2") ; le SKU sert de secours.
 */
export function getPlusRank(
  countryCode: string | undefined,
  sku: string | null | undefined,
  name?: string | null,
): number {
  const candidates = [name, sku].filter(Boolean) as string[];

  for (const candidate of candidates) {
    const lastIndex = LAPAIRE_PLUS_ALWAYS_LAST.findIndex(
      (entry) => normalize(entry) === normalize(candidate),
    );
    if (lastIndex !== -1) return UNRANKED_RANK + 1 + lastIndex;
  }

  if (!countryCode) return UNRANKED_RANK;
  const table = LAPAIRE_PLUS_RANKING[countryCode];
  if (!table) return UNRANKED_RANK;
  const index = Object.entries(table).reduce<Record<string, number>>((acc, [key, rank]) => {
    acc[normalize(key)] = rank;
    return acc;
  }, {});
  for (const candidate of candidates) {
    const rank = index[normalize(candidate)];
    if (rank !== undefined) return rank;
  }
  return UNRANKED_RANK;
}

